var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.routeName))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/admin/parent-corporation", role: "button" }
              },
              [_vm._v("\n                        back\n                    ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createparentCorp.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.corps.length
                  ? _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "multiselect",
                          {
                            attrs: {
                              placeholder: "Associate child Corporations",
                              multiple: true,
                              taggable: true,
                              options: _vm.corps.map(function(type) {
                                return type.corporationId
                              }),
                              "custom-label": function(opt) {
                                return _vm.corps.find(function(x) {
                                  return x.corporationId == opt
                                }).name
                              },
                              required: ""
                            },
                            model: {
                              value: _vm.parentCorp.csvCorporationIds,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.parentCorp,
                                  "csvCorporationIds",
                                  $$v
                                )
                              },
                              expression: "parentCorp.csvCorporationIds"
                            }
                          },
                          [
                            _vm._v(
                              "\n                                >\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.name,
                          expression: "rules.name"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Parent Corporation Title",
                        placeholder: "Enter Title",
                        "data-vv-name": "name",
                        "cus-name": "name",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.parentCorp.name,
                        callback: function($$v) {
                          _vm.$set(_vm.parentCorp, "name", $$v)
                        },
                        expression: "parentCorp.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.description,
                          expression: "rules.description"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Description",
                        placeholder: "Enter Description",
                        "data-vv-name": "Description",
                        "cus-name": "Description",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields
                      },
                      model: {
                        value: _vm.parentCorp.description,
                        callback: function($$v) {
                          _vm.$set(_vm.parentCorp, "description", $$v)
                        },
                        expression: "parentCorp.description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.status.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-3" },
                      [
                        _c("fg-select", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: _vm.rules.active,
                              expression: "rules.active"
                            }
                          ],
                          attrs: {
                            label: "Active",
                            "data-vv-name": "active",
                            "cus-name": "active",
                            "has-errors": _vm.errors,
                            "is-fields": _vm.fields,
                            list: _vm.status,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.parentCorp.active,
                            callback: function($$v) {
                              _vm.$set(_vm.parentCorp, "active", $$v)
                            },
                            expression: "parentCorp.active"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-fill btn-block",
                  attrs: {
                    type: "submit",
                    disabled:
                      _vm.errors.any() ||
                      !_vm.parentCorp.csvCorporationIds ||
                        _vm.parentCorp.csvCorporationIds.length === 0
                  }
                },
                [
                  _vm._v(
                    "\n                  Create Parent Corporation\n                "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ff0160c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ff0160c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/ParentCorps/CreateParentCorp.vue
// module id = 6lUY
// module chunks = 0